<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-img
        height="100vh"
        width="100%"
        :src="$vuetify.breakpoint.smAndUp ? '/imagenes/Portadas.jpg' : '/imagenes/Portada-Cel.jpg'"
      >
      </v-img>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-row class="d-flex justify-center align-center">
          <v-col cols="10" sm="10" md="8">
            <div
              class="pa-3 d-flex justify-center align-center"
              style="background-color: #313131"
            >
              <h3 class="white--text text-center">
                Inscríbete con nosotros y se parte de la comunidad Vizcaya
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <FAQ :titlecol="12" :questionscol="12" />
    <Contact originProcedence="Promo inscripcion" bgClass="white " />
  </v-container>
</template>
<style scoped>
.primary-pattern {
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
@media screen and (max-width: 580px) {
  .primary-pattern {
    height: 50vh;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
<script>
import { mapState } from "vuex";
import Contact from "../components/Contact.vue";
import FAQ from "../components/FAQ.vue";
export default {
  components: {
    Contact,
    FAQ,
  },
  data: () => ({
    snackbar: false,
    snackbarColor: "info",
    snackbarText: "",
  }),
  mounted() {
    this.$store.dispatch("home/setModalImagen", false);
  },
  computed: {
    ...mapState({}),
    routeComputed() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "/imagenes/Portadas.jpg";
      }
      return "/imagenes/Portada-Cel.jpg";
    },
    routeNum() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "/imagenes/Portada-Num-Vizcaya-Cel.jpg";
      }
      return "/imagenes/Portada-Num-vizcaya.jpg";
    },
  },
};
</script>
